export default {
  setCompany(state, payload) {
    state.company = payload;
  }
};
